import { useCallback, useState } from 'react';

import { isMobileVersion } from '../utils/functions';

import { useWindowEventListener } from './use-window-event-listener';

export const useIsMobile = (admin = false) => {
  const [isMobile, setIsMobile] = useState(isMobileVersion(admin));

  const handler = useCallback(() => setIsMobile(isMobileVersion(admin)), [
    admin,
  ]);

  useWindowEventListener('resize:width', handler);

  return isMobile;
};
